export const dispatchStorageEvent = () => {
    const event = new Event("storageChanged");
    window.document.dispatchEvent(event);
}
